import { styled } from "@mui/material/styles";

// Components
import { StyledCard } from "~/components/Common";

const styledName = "LayoutDelete";

export const StyledWrapper = styled(StyledCard, { name: styledName })({
  "&": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
});

export const StyledIcon = styled("img", { name: styledName })({
  "&": {
    height: "100px",
    opacity: "0.5",
  },
});

export const StyledDeleteAction = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    justifyContent: "space-around",
    width: "100%",
    marginTop: "20px",
  },
});
